module.exports = __webpack_public_path__ + "img/val-2-min.61d70546.jpg";